module.exports = __webpack_public_path__ + "media/images/re/marcus-schorn-553219-unsplash-586f4b2d980a2c92e70443e7c61a85e6.png";